import Header from "./../../../Headers/HeaderForAreLoggedIn/index.vue"
import Footer from "./../../../Footers/Footer/index.vue"
import ProgressHUD from "./../../../ProgressHUD/index.vue"
import QuestionsAnswers from "./../../Widget/QuestionsAnswers/index.vue"
import ReputationData from "./../../Widget/ReputationData/index.vue"
import { Api, Toast } from './../../../../services'
import { ProductUpdateMixin } from './../../../mixins/ProductUpdate.mixin.js'
import { VueEditor } from "vue2-editor"
let vm = require('vue');

export default {
  name: "ServicesEdit",
  props: [],
  mixins:[ProductUpdateMixin],
  components: {
    Header,
    Footer,
    ProgressHUD,
    QuestionsAnswers,
    ReputationData,
    VueEditor
  },
  mounted() {},
  data() {
    return {
      product: {
        _id: "",
        name: "",
        description: "",
        specs: "",
        price: "",
        type: "",
        rangePrices: "",
        details: {
          number: "",
          weight: "",
          shipping: "",
          manufacture: "",
          asin: "",
        },
        images: [""],
        available: 0,
        accept: true,
        draft: false,
      },
      reviews: [],
      comment: [],
      draft: false,
      itemCount: 1,
      validationMessage: null,
      curentImage: '',
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      newImages: []
    }
  },
  methods: {

    saveDraftProduct() {      
      this.draft = true;
      this.saveProduct();
    }, 

    async saveProduct() {
      if (!this.draft) {
        let isValid = await this.$validator.validateAll("firstForm")
        if (!isValid
            || !this.editorIsNotEmpty(this.product.description)
            || !this.editorIsNotEmpty(this.product.specs)
        ) {
          Toast.validationFieldsError({ toast: this.$toast })
          return
        }
      } else {
        if (this.product.name == "") {
          Toast.validationFieldsError({ toast: this.$toast })
        }
      } 
      
      var formData = new FormData()
      for (var key in this.product) {
        if (String(key) == "details" || String(key) == "images") break
        formData.append(key, this.product[key])
      }

      // Append images to formData 
      if(!this.draft)    
        for (
          var index = 0;
          !(!(index < this.product.images.length) || !(index < 5)); // Upload 5 images or less
          index++
        ) {
          formData.append("files" + index, this.product.images[index])
        }

      formData.append("details", String(JSON.stringify(this.product.details)))
      formData.append("name", this.product.name)
      formData.append("description", this.product.description)
      formData.append("rangePrices", this.product.rangePrices)
      formData.append("email", this.product.email)
      formData.append("phone", this.product.phone)
      formData.append("region", this.product.region)
      formData.append("images", this.product.images)
      formData.append('draft', this.draft)

      var response = await Api.editService(formData)
      if (response.data) {
        console.log(response)
        this.$router.push("/service/private/" + this.product._id)
      } else {
        console.log(response.error)
        this.validationMessage = "Something went wrong."
        this.$refs.progress.hide()
      }
    },
  },
  computed: {},
  beforeCreate() {},
  async created() {
    var response = await Api.getProductById(this.$route.params.id)

    if (response.data && !response.data.error) {
      this.product = response.data.results.product
      this.reviews = response.data.results.opinion
      this.comment = response.data.results.comment
      this.newImages = [].concat(this.product.images);
      console.log(this.newImages)

    } else {
      this.validationMessage = "Something went wrong."
      console.error("Something went wrong.")
    }

    this.$refs.progress.hide()
  },
  mounted() {
    $(".modal").modal()
    $("select").material_select()
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Services/Edit/ServicesEdit.component.js